// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

/* eslint-disable no-console */

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  //console.log(evt.detail.product);
  window.dispatchEvent(new CustomEvent("Hitsy:cartUpdated"));

});

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:updated", function (evt) {
  console.log("Cart updated");
 // console.log(evt.detail.cart);
  window.dispatchEvent(new CustomEvent("Hitsy:cartUpdated"));

});

// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
 // console.log(evt.detail.errorMessage);
});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
 // console.log(evt.detail.cart);
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// ================================================================================
// Quick-cart discount code
// ================================================================================

function updateQuickCartDiscountMarkup(sectionId) {
  var sectionUrl = window.Shopify.routes.root + "cart?section_id=" + encodeURIComponent(sectionId);

  return fetch(sectionUrl, { credentials: "include" })
    .then(function (response) {
      if (!response.ok) throw new Error("Unable to refresh the quick cart.");
      return response.text();
    })
    .then(function (html) {
      var parsed = new DOMParser().parseFromString(html, "text/html");
      var currentCart = document.querySelector('[data-section-id="' + sectionId + '"]');
      var refreshedCart = parsed.querySelector('[data-section-id="' + sectionId + '"]');

      if (!currentCart || !refreshedCart) return;

      [
        ".quick-cart__items",
        ".quick-cart__footer-subtotal span",
        "[data-quick-cart-cart-discounts]"
      ].forEach(function (selector) {
        var currentElement = currentCart.querySelector(selector);
        var refreshedElement = refreshedCart.querySelector(selector);

        if (currentElement && refreshedElement) {
          currentElement.innerHTML = refreshedElement.innerHTML;
        }
      });
    });
}

function applyQuickCartDiscount(button) {
  var discountWrapper = button.closest(".quick-cart__discount");
  var quickCart = button.closest("[data-section-id]");
  var input = discountWrapper && discountWrapper.querySelector("[data-quick-cart-discount-input]");
  var status = discountWrapper && discountWrapper.querySelector("[data-quick-cart-discount-status]");
  var code = input ? input.value.trim() : "";

  if (!code) {
    status.textContent = "Enter a discount code.";
    status.classList.add("is-error");
    input.focus();
    return;
  }

  button.disabled = true;
  button.setAttribute("aria-busy", "true");
  status.textContent = "Applying...";
  status.classList.remove("is-error");

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    },
    body: JSON.stringify({ discount: code })
  })
    .then(function (response) {
      if (!response.ok) throw new Error("Shopify could not apply this code.");
      return response.json();
    })
    .then(function (cart) {
      status.textContent = "Code added. Eligibility is confirmed at checkout.";
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent("quick-cart:updated", { detail: { cart: cart } }));

      if (quickCart && quickCart.dataset.sectionId) {
        return updateQuickCartDiscountMarkup(quickCart.dataset.sectionId);
      }
    })
    .catch(function (error) {
      status.textContent = error.message || "Unable to apply the code. Please try again.";
      status.classList.add("is-error");
    })
    .finally(function () {
      button.disabled = false;
      button.removeAttribute("aria-busy");
    });
}

document.addEventListener("click", function (event) {
  var button = event.target.closest("[data-quick-cart-discount-apply]");
  if (button) applyQuickCartDiscount(button);
});

document.addEventListener("keydown", function (event) {
  if (event.key !== "Enter" || !event.target.matches("[data-quick-cart-discount-input]")) return;

  event.preventDefault();
  var discountWrapper = event.target.closest(".quick-cart__discount");
  var button = discountWrapper && discountWrapper.querySelector("[data-quick-cart-discount-apply]");
  if (button) applyQuickCartDiscount(button);
});

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  //console.log(evt.detail.variant);
});

// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  //console.log(evt.detail.quantity, evt.detail.variant);
});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
  console.log("Quick view loaded");
  window.dispatchEvent(new CustomEvent("Hitsy:cartUpdated"));

});
/* eslint-enable no-console */
